module.exports = __webpack_public_path__ + "img/school_esyc.61ac3d60.png";